import { cn } from '@/lib/utils'
import type { SheetInfo } from '@/service/api'

interface SheetTabsProps {
  sheets: SheetInfo[]
  activeSheet: string
  onSheetChange: (tableName: string) => void
  className?: string
}

const SheetTabs = ({
  sheets,
  activeSheet,
  onSheetChange,
  className,
}: SheetTabsProps) => {
  if (sheets.length <= 1) {
    return null
  }

  return (
    <div className={cn('flex items-end gap-0.5 overflow-x-auto py-1', className)}>
      {sheets.map((sheet) => {
        const isActive = sheet.table_name === activeSheet
        return (
          <button
            key={sheet.table_name}
            onClick={() => onSheetChange(sheet.table_name)}
            onPointerDown={(e) => e.stopPropagation()}
            className={cn(
              'flex items-center gap-1.5 px-3 py-1.5 text-sm border border-b-0 rounded-t-md transition-colors min-w-[80px] max-w-[200px]',
              isActive
                ? 'bg-white dark:bg-dark-card border-gray-300 dark:border-gray-600 text-gray-900 dark:text-dark-text font-medium -mb-px z-10'
                : 'bg-gray-100 dark:bg-dark-accent border-gray-200 dark:border-dark-border text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-dark-muted hover:text-gray-800 dark:hover:text-gray-300'
            )}
          >
            <span className="truncate" title={sheet.name}>
              {sheet.name}
            </span>
            <span className="text-xs text-gray-400 dark:text-gray-500 shrink-0">
              ({sheet.row_count.toLocaleString()})
            </span>
          </button>
        )
      })}
    </div>
  )
}

export default SheetTabs
